// extracted by mini-css-extract-plugin
export var currencyInput = "_i0-1";
export var currencySymbol = "_i0-0";